<template>
	<div class="container">
		<input class="back-button" type="button" value="Back" @click="backToBlogs">
		<div v-if="state.blog" class="reader">
			<article>
				<header>
					<h1>{{ state.blog.title }}</h1>
					<h4>Created by: {{ state.blog.author }}</h4>
				</header>
				<section class="body-container">
					<!-- <span v-text="getFile()"></span> -->
					<span v-html="getFile()"></span>
				</section>
				<hr>
				<footer>
					<p>Posted on <time :datetime="state.blog.date">{{ formatDate(state.blog.created_date) }}</time></p>
				</footer>
			</article>
		</div>	
	</div>
</template>

<script>
import { computed, onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// import file from 'raw-loader!../assets/testBlog.txt'
import postService from '../services/PostDataService'

export default {
	name: 'BlogReader',
	setup() {
		const route = useRoute();
		const router = useRouter();
		const blogId = computed(() => route.params.id)
		const backToBlogs = () => router.push('/blog')

		const state = reactive({
			blog: null
		})

		// function getFile() {
		// 	return file
		// }

		function formatDate(pass) {
			return new Date(pass).toDateString().split(' ').splice(-3, 3).join(' ')
		}

		onMounted(() => {
			postService.getPost(blogId.value).then(res => {
				console.log(`Returned Data: ${res.data}`)
				state.blog = res.data.Items[0]
				console.log(state.blog)
			}).catch(() => console.log('error thrown getting posts'))
		})

		function getFile() {
			return require(`html-loader!markdown-loader!../assets/${this.state.blog.content}`);
		}

		return {
			blogId,
			state,
			getFile,
			backToBlogs,
			formatDate
		}
	}
}
</script>

<style scoped>

.container {
	margin: 25pt 50pt;
	box-sizing: border-box;
}

.back-button {
	padding: 6pt 25pt;
	background: black;
	color: white;
	border: none;
	border-radius: 10pt;
}

.back-button:hover {
	cursor: pointer;
	background: white;
	color: black;
}

.reader {
	margin: 20pt 50pt;
	padding: 0 75pt;
	border: solid white;
}

article {
	display: flex;
	justify-content: center;
	flex-direction: column;
}

.body-container {
	display: block;
	align-self: flex-start;
	white-space: pre-wrap;
	text-align: left;
}

hr {
	width: 100%;
}

footer p {
	font-size: 10pt;
}

</style>